import { RouteObject } from "react-router-dom";
import AuthLayout from "../../layout/AuthLayout";
import LoginPage from "../../pages/LoginPage";
import SignupPage from "../../pages/SignupPage";
import TermsPage from "../../pages/Terms";
import AboutUs from "../../pages/AboutUs";

//homePages
import HomePage from "../../pages/HomePage";

//guidepages
import GuidePage from "../../pages/GuidPage";
import GuideMain from "../../pages/GuidPage/GuideMain";
import SignupGuide from "../../pages/GuidPage/SignupGuide";

//courses
import CoursesPage from "../../pages/Courses";
import CourseMain from "../../pages/Courses/CourseMain";
import SingleCourse from "../../pages/Courses/SingleCourse";

//notifs
import Notifs from "../../pages/Notifs";
import NotifsMainPage from "../../pages/Notifs/NotifsMain";

const authRoutes: RouteObject[] = [
  {
    path: "/",
    element: <AuthLayout />,
    children: [
      { path: "/login", element: <LoginPage /> },
      { path: "/signup", element: <SignupPage /> },
      { path: "/terms", element: <TermsPage /> },
      {
        path: "/guides",
        element: <GuidePage />,
        children: [
          {
            path: "/guides",
            element: <GuideMain />,
          },
          {
            path: "/guides/signup-guides",
            element: <SignupGuide />,
          },
          {
            path: "/guides/login",
            element: <SignupGuide />,
          },
          {
            path: "/guides/condignment-owner",
            element: <SignupGuide />,
          },
          {
            path: "/guides/drivers",
            element: <SignupGuide />,
          },
        ],
      },
      {
        path: "/courses",
        element: <CoursesPage />,
        children: [
          {
            path: "/courses",
            element: <CourseMain />,
          },
          {
            path: ":courseId",
            element: <SingleCourse />,
          },
        ],
      },
      {
        path: "/notifs",
        element: <Notifs />,
        children: [
          {
            path: "/notifs",
            element: <NotifsMainPage />,
          },
        ],
      },
      { path: "/aboutus", element: <AboutUs /> },
    ],
  },
];

export default authRoutes;
